import { render } from "./DetailsHospitalisation.vue?vue&type=template&id=a7e8b476&scoped=true"
import script from "./DetailsHospitalisation.vue?vue&type=script&lang=js"
export * from "./DetailsHospitalisation.vue?vue&type=script&lang=js"

import "./DetailsHospitalisation.vue?vue&type=style&index=0&id=a7e8b476&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7e8b476"]])

export default __exports__